import React, { FC } from 'react';
import { RocheUILeadText } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type RocheLeadTextProps = BlokToComponentProps<{ slotted_content: string }>;

export const RocheLeadText: FC = ({ blok, slot }: RocheLeadTextProps) => (
  <div slot={slot}>
    <RocheUILeadText lead={blok.slotted_content} />
  </div>
);
